import { useState } from "react";
import Sponsor from "./Sponsor";
import Generico from "./Generico";

function Nacion({ userEmail }) {
  const email = userEmail?.toLowerCase() || "";

  // 1) Debe ser un correo institucional
  const esME = email.endsWith("@me.cba.gov.ar");

  // 2) No debe comenzar con EE + números
  const esCorreoValido =
    esME && !email.startsWith("ee");  // <<--- ESTA ES LA VALIDACIÓN CLAVE

  // Estado para mostrar u ocultar Generico
  const [mostrarGenerico, setMostrarGenerico] = useState(false);

  return (
    <div className="container contOption">

      {/* Mostrar botón solo si es un usuario ME válido y NO empieza con EE */}
      {esCorreoValido && (
        <div className="mx-3 my-3">
          <button
            className="btn btn-outline-primary"
            onClick={() => setMostrarGenerico(!mostrarGenerico)}
          >
            {mostrarGenerico ? "Ocultar Generico" : "Mostrar Generico"}
          </button>
        </div>
      )}

      {/* GENERICO solo si es correo ME válido y activado */}
      {esCorreoValido && mostrarGenerico && <Generico />}

      {/* SPONSOR cuando no está activado Generico */}
      {!mostrarGenerico && <Sponsor />}

    </div>
  );
}

export default Nacion;
